/**
 * Co napisać na przycisku, który pokazuje liczbę wyników na żywo.
 *
 * Wydzielone z widoku, bo to są trzy stany i każdy z nich ma powód:
 *
 *   • LICZYMY, a nic jeszcze nie wiadomo → kropki. Napis „Pokaż 0 ofert" w czasie
 *     liczenia byłby kłamstwem trwającym ułamek sekundy, ale zawsze w tę samą stronę:
 *     zniechęcającą.
 *   • LICZYMY, a znamy poprzednią liczbę → zostaje POPRZEDNIA. React Query trzyma ją
 *     przez `keepPreviousData`, a przycisk dzięki temu nie skacze między „128" a „…"
 *     przy każdym dotknięciu chipa.
 *   • ZERO → osobne zdanie z podpowiedzią, co zrobić, a nie „Pokaż 0 ofert". Przycisk
 *     zostaje aktywny, bo zamknięcie nakładki i zobaczenie pustej listy to legalny ruch;
 *     blokada zostawiłaby człowieka w pułapce bez wyjścia poza strzałką wstecz.
 */
export type StanLicznika =
  | { rodzaj: 'liczymy' }
  | { rodzaj: 'pusto' }
  | { rodzaj: 'liczba'; ile: number };

export function stanLicznika(ile: number | null | undefined, liczy: boolean): StanLicznika {
  if (ile == null) return { rodzaj: 'liczymy' };
  if (ile === 0 && !liczy) return { rodzaj: 'pusto' };
  if (ile === 0) return { rodzaj: 'liczymy' };
  return { rodzaj: 'liczba', ile };
}
